if (!customElements.get("testimonial-gallery")) {
  customElements.define(
    "testimonial-gallery",
    class TestimonialGallery extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        this.slides = Array.from(this.querySelectorAll("[data-testimonial-gallery-slide]"));
        this.dots = Array.from(this.querySelectorAll("[data-testimonial-gallery-dot]"));
        this.activeIndex = Math.max(
          this.slides.findIndex((slide) => slide.classList.contains("is-active")),
          0
        );
        this.touchStartX = 0;

        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleTouchStart = this.handleTouchStart.bind(this);
        this.handleTouchEnd = this.handleTouchEnd.bind(this);
        this.handleBlockSelect = this.handleBlockSelect.bind(this);

        const { signal } = this.abortController;

        this.dots.forEach((dot) => {
          dot.addEventListener(
            "click",
            () => {
              this.setActiveIndex(Number(dot.getAttribute("data-testimonial-gallery-index")));
            },
            { signal }
          );
        });

        this.addEventListener("keydown", this.handleKeydown, { signal });
        this.addEventListener("touchstart", this.handleTouchStart, { passive: true, signal });
        this.addEventListener("touchend", this.handleTouchEnd, { passive: true, signal });
        document.addEventListener("shopify:block:select", this.handleBlockSelect, { signal });

        this.setActiveIndex(this.activeIndex, { focusDot: false });
      }

      disconnectedCallback() {
        if (this.abortController) {
          this.abortController.abort();
        }
      }

      setActiveIndex(index, options = {}) {
        if (!this.slides.length || Number.isNaN(index)) {
          return;
        }

        const { focusDot = false } = options;
        const nextIndex = Math.max(0, Math.min(index, this.slides.length - 1));
        this.activeIndex = nextIndex;

        this.slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === nextIndex;
          slide.classList.toggle("is-active", isActive);
          slide.toggleAttribute("hidden", !isActive);
          slide.setAttribute("aria-hidden", isActive ? "false" : "true");
        });

        this.dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === nextIndex;
          dot.classList.toggle("is-active", isActive);

          if (isActive) {
            dot.setAttribute("aria-current", "true");

            if (focusDot) {
              dot.focus({ preventScroll: true });
            }
          } else {
            dot.removeAttribute("aria-current");
          }
        });
      }

      handleKeydown(event) {
        if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") {
          return;
        }

        event.preventDefault();
        const direction = event.key === "ArrowRight" ? 1 : -1;
        this.setActiveIndex(this.activeIndex + direction, { focusDot: true });
      }

      handleTouchStart(event) {
        this.touchStartX = event.changedTouches[0].clientX;
      }

      handleTouchEnd(event) {
        const touchEndX = event.changedTouches[0].clientX;
        const deltaX = touchEndX - this.touchStartX;

        if (Math.abs(deltaX) < 48) {
          return;
        }

        this.setActiveIndex(this.activeIndex + (deltaX < 0 ? 1 : -1));
      }

      handleBlockSelect(event) {
        const slide = event.target.closest("[data-testimonial-gallery-slide]");

        if (!slide || !this.contains(slide)) {
          return;
        }

        this.setActiveIndex(Number(slide.getAttribute("data-testimonial-gallery-index")));
      }
    }
  );
}
